import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { t } from "i18next";
import { IS_MOBILE } from "../../../constants/breakpoints";

//import general components
import BaseTabs from "../../common/base-tabs/base-tabs";

//import view components
import IntFlightInformation from "./int-flight-information";
import PassengersInformation from "./passengers-information";
import HotelInformation from "./hotel-information";
import IntFlightInformationMobile from "./mobile/int-flight-information";
import PassengersInformationMobile from "./mobile/passenger-information";
import HotelInformationMobile from "./mobile/hotel-information";

function InternationalInformation() {
    //sessionStorage variables
    const intFlightInformation = JSON.parse(sessionStorage.getItem("intFlightInformation"));
    const intFlightPassengers = JSON.parse(sessionStorage.getItem("intFlightPassengers"));
    const selectedIntFlight = JSON.parse(sessionStorage.getItem("selectedIntFlight"));
    const selectedHotel = JSON.parse(sessionStorage.getItem("selectedHotel"));
    const selectedIntRooms = JSON.parse(sessionStorage.getItem("selectedIntRooms"));
    const intHotelPassengers = JSON.parse(sessionStorage.getItem("intHotelPassengers")) || JSON.parse(sessionStorage.getItem("hotelPassengers")); // we need hotelPassengers because when the international flight is selected, it reads the international information and if the international flight selected with the domestic hotel of grs (in itinerary), we need the hotelPassengers
    const selectedRooms = JSON.parse(sessionStorage.getItem("selectedRooms"));

    //Flatten the array of passengers
    const [flatPassengersList, setFlatPassengersList] = useState([]);
    useEffect(() => {
        const passengers = intHotelPassengers?.rooms?.flatMap(room => room.passengers) || intHotelPassengers?.passengers || [];
        setFlatPassengersList({ passengers });
    }, []);

    //handle tab change
    const [activeTab, setActiveTab] = useState({ departure: true, return: false, hotel: !selectedIntFlight?.segments?.length ? true : false });
    const handleTabChange = type => {
        setActiveTab({ [type]: true });
    };

    //list of tabs
    const tabList = [
        { type: "departure", title: t("departureFlight"), activeTab: activeTab?.departure, disable: !selectedIntFlight?.segments?.length },
        { type: "return", title: t("returnFlight"), activeTab: activeTab?.return, disable: !selectedIntFlight?.return_segments?.length },
        { type: "hotel", title: t("hotel"), activeTab: activeTab?.hotel, disable: !selectedIntRooms && !selectedRooms },
    ];

    return (
        <>
            {IS_MOBILE ? (
                <Grid container item xs={12} justifyContent="space-between" rowGap={3}>
                    <BaseTabs handleTabChange={handleTabChange} list={tabList} style={{ top: "3rem" }} />
                    {selectedIntFlight && (activeTab?.departure || activeTab?.return) && (
                        <>
                            <IntFlightInformationMobile
                                selectedFlight={activeTab?.departure ? selectedIntFlight?.segments : selectedIntFlight?.return_segments}
                                cabin={selectedIntFlight?.cabin}
                            />
                            <PassengersInformationMobile title={t("flightPassenger")} information={intFlightPassengers} type="int-flight" />
                        </>
                    )}

                    {activeTab.hotel && (
                        <>
                            <HotelInformationMobile selectedHotel={selectedHotel} />
                            <PassengersInformationMobile title={t("supervisor")} information={flatPassengersList} />
                        </>
                    )}
                </Grid>
            ) : (
                <Grid container item xs={12} justifyContent="space-between" rowGap={5}>
                    {!!selectedIntFlight && (
                        <IntFlightInformation title={t("departureTicket")} details={selectedIntFlight?.segments} iconName="departure-icon" />
                    )}
                    {!!selectedIntFlight && !!intFlightInformation.returnDate ? (
                        <IntFlightInformation title={t("returnTicket")} details={selectedIntFlight?.return_segments} iconName="return-icon" />
                    ) : null}
                    {!!intFlightPassengers && (
                        <PassengersInformation title={t("flightPassenger")} information={intFlightPassengers} type="int-flight" />
                    )}
                    {(!!selectedIntRooms || !!selectedRooms) && <HotelInformation />} {/*for dometic hotel of grs when it is selected with the international flight*/}

                    {(!!intHotelPassengers&& !!selectedIntRooms) && <PassengersInformation title={t("hotelPassenger")} information={flatPassengersList} type="intHotel" />}

                    {(!!intHotelPassengers && !!selectedRooms) && <PassengersInformation title={t("hotelPassenger")} information={flatPassengersList} type="hotel" />} {/*for dometic hotel of grs when it is selected with the international flight*/}
                </Grid>
            )}
        </>
    );
}

export default InternationalInformation;
